import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types/api';

export interface EmployeeToken {
  id?: number;
  token?: string;
  email?: string;
  userId?: number;
  companyId?: number | string;
}

const URL = '/v2/employee-token';

class EmployeeTokenService {
  // Lookup by token or userId. Used by ActivateBenefits when a ?token=
  // param is present in the URL.
  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<EmployeeToken>> {
    return axios.get(URL, config);
  }

  // Create a new verification email for the given company email.
  static create(
    data: { email: string; userId: number },
    config?: AxiosRequestConfig
  ): Promise<DataResponse<EmployeeToken>> {
    return axios.post(URL, data, config);
  }

  // Resend an existing verification email.
  static patch(
    data: EmployeeToken,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<EmployeeToken>> {
    return axios.patch(URL, data, config);
  }
}

export { EmployeeTokenService };
